import styled, { css } from "styled-components";
import { ProductNameVariant } from "../components/ProductName";

interface StyleProps {
  $variant: ProductNameVariant;
}

const highlightVariant = css`
  @media (max-width: 1225px) {
    .akn-product-price {
      font-size: 15px;
      font-weight: bold;
    }
  }
`;
const modalVariant = css`
  & .akn-product-price {
    color: black;
    font-weight: 600;
    font-size: 1.25rem;
  }
`;

function getVariant(variant: ProductNameVariant) {
  if (variant === "highlight") return highlightVariant;
  if (variant === "modal") return modalVariant;
  return "";
}

export const DivProductPrice = styled.span<StyleProps>`
  display: flex;
  flex-direction: column;

  & .akn-product-price > .akn-product-discount {
    margin-left: 10px;
    margin-bottom: 10px;
  }

  & {
    .akn-product-price {
      font-weight: bold;
      color: var(--live-button-color);
      display: flex;
    }
    .akn-product-retail-price {
      color: #9b9b9b;
      text-decoration: line-through;
    }
    .akn-price-and-retail {
      display: flex;
      gap: 1ch;
    }
  }

  ${({ $variant }) => getVariant($variant)}
`;
